module.exports = __webpack_public_path__ + "img/privacy.73d3b64a.svg";